import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {WizardProgressIndicatorComponentProps} from "./wizard-progress-indicator.component.props";
import {IWizardStepViewModel} from "../../models/wizard/wizard-step.view-model.interface";

function computeRegularStepWidth(stepsCount: number): number {
    if(stepsCount > 15) {
        return 4;
    }

    if(stepsCount >= 9) {
        return 8;
    }

    if(stepsCount >= 6) {
        return 16;
    }

    return 32;
}

function computeCurrentStepWidth(stepsCount: number): number {
    return 2 * computeRegularStepWidth(stepsCount);
}


const StepLineBox = styled.span<{$stepsCount: number}>`
    border-radius: 2px;
    width: ${props => computeRegularStepWidth(props.$stepsCount)}px;
    height: 5px;
`;


const PreviousStepLineBox = styled(StepLineBox)`
  background-color: ${props => props.theme.colors.medium};
`;


const CurrentStepLineBox = styled(StepLineBox)`
    background-color: ${props => props.theme.colors.primary};
    width: ${props => computeCurrentStepWidth(props.$stepsCount)}px;
`;

const NextStepLineBox = styled(StepLineBox)`
    background-color: ${props => props.theme.colors.medium};
`;


const WizardProgressIndicatorBox = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 6px;
`;

export const WizardProgressIndicatorSmallScreenComponent: React.FC<WizardProgressIndicatorComponentProps> = observer((props) => {
    const wizard = props.getWizard();
    const stepsCount = wizard.steps.length;
    const currentStepIndex = wizard.currentStep?.index ?? -1;

    const renderOneStep = (step: IWizardStepViewModel) => {
        if(!step.isVisible) {
            return null;
        }
        const stepIndex = step.index;
        if(stepIndex === currentStepIndex) {
            return (<CurrentStepLineBox key={step.title} $stepsCount={stepsCount}/>);
        } else if (stepIndex < currentStepIndex) {
            return (<PreviousStepLineBox key={step.title} $stepsCount={stepsCount}/>);
        } else {
            return (<NextStepLineBox key={step.title} $stepsCount={stepsCount}/>);
        }
    }

    return (
        <WizardProgressIndicatorBox>
            {wizard.steps.map(renderOneStep)}
        </WizardProgressIndicatorBox>
    );
});
